module.exports = __webpack_public_path__ + "img/Logout.89fb65f8.svg";